"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1565],{

/***/ 21565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SearchBox": function() { return /* binding */ SearchBox; },
  "default": function() { return /* binding */ components_SearchBox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
;// CONCATENATED MODULE: ./components/SearchBox/Option.tsx


var Option = function(param) {
    var label = param.label, items = param.items, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-start items-center font-normal flex-1 gap-2 p-2",
                children: label
            }),
            items && items.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "p-2 cursor-pointer hover:bg-gray-100",
                    onClick: function() {
                        onClick(item.value);
                    },
                    children: item.label
                }, index);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/SearchBox/index.tsx




var SearchBox = function(param) {
    var placeholder = param.placeholder, className = param.className, style = param.style, onSearch = param.onSearch, Icon = param.Icon, onClick = param.onClick, onSelect = param.onSelect, options = param.options;
    var ref = (0,react.useState)(false), trigger = ref[0], setTrigger = ref[1];
    var inputRef = (0,react.useRef)(null);
    var dropDownRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var onMouseClick = function(e) {
            if (inputRef.current && !inputRef.current.contains(e === null || e === void 0 ? void 0 : e.target) && dropDownRef.current && !dropDownRef.current.contains(e === null || e === void 0 ? void 0 : e.target)) {
                setTrigger(false);
            }
        };
        document.addEventListener("click", onMouseClick);
        return function() {
            document.removeEventListener("click", onMouseClick);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className + "flex w-full relative bg-white rounded-md",
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full justify-center items-center shadow rounded-md",
                ref: inputRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: "flex-1 outline-none border-none px-2 py-1",
                        onChange: function(e) {
                            onSearch === null || onSearch === void 0 ? void 0 : onSearch(e.currentTarget);
                        },
                        placeholder: placeholder,
                        onClick: function() {
                            return setTrigger(true);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cursor-pointer px-5 p-3 h-full text-white bg-primary rounded-r-md flex justify-center items-center",
                        "aria-label": "Search",
                        title: "Search",
                        onClick: function() {
                            setTrigger(false);
                            onClick === null || onClick === void 0 ? void 0 : onClick();
                        },
                        children: Icon && Icon || /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaSearch */.U41, {})
                    })
                ]
            }),
            trigger && options && options.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute w-full max-h-[250px] overflow-y-scroll rounded-b-md overflow-x-hidden mt-1 bg-white border border-gray-200 top-full transition-all ease-in-out duration-200 text-primary scroll-bar",
                ref: dropDownRef,
                children: options.map(function(option, index) {
                    return option && /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                        label: option.label,
                        items: option.items,
                        onClick: function(event) {
                            setTrigger(false);
                            onSelect === null || onSelect === void 0 ? void 0 : onSelect(event);
                        }
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var components_SearchBox = (SearchBox);


/***/ })

}]);